import React, { cloneElement, useMemo, useCallback } from "react";
import { isEmpty } from "lodash";
import { Collapse } from "react-bootstrap";
import Pagination from "react-js-pagination";

import { Toggle, OnlineLink, Skeleton } from "components";


import EyeIcon from "static/images/showFile.png";
import styles from "./search.module.scss";

const SearchResultSection = ({
	name,
	title,
	getIcon,
	renderItem,
	getLink,
	page,
	setPage,
	open,
	setOpen,
	loading,
	data,
}) => {
	const visibleResults = useMemo(
		() => data?.items?.slice(0, 50),
		[data?.items],
	);

	const handlePageChange = useCallback(
		page => {
			const pageIndex = page - 1;
			setPage(pageIndex);
		},
		[setPage],
	);

	const icon = useMemo(
		() =>
			cloneElement(getIcon(), {
				className: styles.sectionIcon,
			}),
		[getIcon],
	);

	const toggle = useCallback(() => setOpen(open => !open), [setOpen]);

	const numberOfMatches = useMemo(
		() =>
			`(${data?.count} ${
				data?.items?.length === 1 ? "match" : "matches"
			})`,
		[data?.items, data?.count],
	);

	const itemCount = useCallback(
		numberItem => {
			if (page === 0) return numberItem;
			else if (page > 0) {
				return numberItem + 50 * page;
			}
		},
		[page],
	);

	if (loading) {
		return (
			<Skeleton
				variant="text"
				height="53px"
				width="100%"
				marginBottom="15px"
				borderRadius="0px"
			/>
		);
	}

	if (isEmpty(visibleResults)) {
		return null;
	}

	return (
		<>
			<div className="mt-1 mb-1">
				<div>
					<div className={styles.header} onClick={toggle}>
						{icon}
						<span className={styles.sectionTitle}>{title}</span>
						<span className={styles.numberOfMatches}>
							{numberOfMatches}
						</span>
						<Toggle onClick={() => {}} isToggled={open} />
					</div>
					<Collapse in={open}>
						<div>
							<ol className={styles.body}>
								{visibleResults?.map((obj, i) => (
									<li
										key={`${name}_item${i}`}
										className={styles.sectionItem}
									>
										<div
											className={styles.sectionItemHeader}
										>
											<p className={styles.itemNumber}>
												{itemCount(i + 1)}
											</p>
											{renderItem(obj)}

											<OnlineLink
												to={getLink(obj)}
												target="_blank"
												className={styles.link}
											>
												<img
													src={EyeIcon}
													alt=""
													width="17"
												/>
											</OnlineLink>
										</div>
										{i !== visibleResults.length - 1 && (
											<div className={styles.divider} />
										)}
									</li>
								))}
							</ol>
							<div className={styles.pagination}>
								<Pagination
									hideFirstLastPages
									prevPageText="〈 PREV"
									nextPageText="NEXT  〉"
									activePage={page + 1}
									itemsCountPerPage={50}
									totalItemsCount={data?.count}
									pageRangeDisplayed={1}
									onChange={handlePageChange}
								/>
							</div>
						</div>
					</Collapse>
				</div>
			</div>
			<div className={`${styles.divider}`} />
		</>
	);
};

export default SearchResultSection;
